import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import { EntityDefaultVarietyId, EntitiesProps } from 'services/entities/types';

// Global Components
import VarietyShortNameValue from 'components/VarietyShortNameValue';

// Global Selectors
import { makeSelectEntityDefaultVarietyId } from 'services/entities/selectors';

type OwnProps = EntitiesProps;

interface ConnectedProps {
    varietyId?: EntityDefaultVarietyId;
}

type Props = OwnProps & ConnectedProps;

export class EntityDefaultVarietyShortNameValueValueComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { varietyId } = this.props;
        if (varietyId) {
            return <VarietyShortNameValue varietyId={varietyId} />;
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    varietyId: makeSelectEntityDefaultVarietyId()
});

export default connect(mapStateToProps)(
    EntityDefaultVarietyShortNameValueValueComponent
);
